<script>
  export let info = [];
  export let ariaLabel = "Ver información adicional";

  $: messages = (Array.isArray(info) ? info : [info])
    .map((message) => String(message ?? "").trim())
    .filter(Boolean);
</script>

{#if messages.length > 0}
  <span class="info-tooltip">
    <button type="button" class="info-trigger" aria-label={ariaLabel}>
      <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
    </button>

    <span class="tooltip-content" role="tooltip">
      {#each messages as message}
        <span class="tooltip-line">{message}</span>
      {/each}
    </span>
  </span>
{/if}

<style>
  .info-tooltip {
    position: relative;
    display: inline-flex;
    align-items: center;
    margin-left: 0.3rem;
    vertical-align: middle;
  }

  .info-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.15rem;
    height: 1.15rem;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: #6c757d;
    font-size: 0.95rem;
    line-height: 1;
    cursor: help;
  }

  .info-trigger:focus-visible {
    outline: 2px solid #86b7fe;
    outline-offset: 2px;
  }

  .tooltip-content {
    position: absolute;
    top: calc(100% + 0.45rem);
    left: 50%;
    z-index: 1100;
    display: block;
    width: max-content;
    max-width: min(22rem, 75vw);
    padding: 0.55rem 0.7rem;
    border-radius: 0.35rem;
    background: #212529;
    box-shadow: none;
    color: #fff;
    font-size: 0.8rem;
    font-weight: 400;
    line-height: 1.35;
    text-align: left;
    transform: translateX(-50%) translateY(-0.2rem);
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s;
  }

  .tooltip-content::before {
    position: absolute;
    bottom: 100%;
    left: 50%;
    border-right: 0.35rem solid transparent;
    border-bottom: 0.4rem solid #212529;
    border-left: 0.35rem solid transparent;
    content: "";
    transform: translateX(-50%);
  }

  .tooltip-line {
    display: block;
  }

  .tooltip-line + .tooltip-line {
    margin-top: 0.3rem;
  }

  .info-tooltip:hover .tooltip-content,
  .info-tooltip:focus-within .tooltip-content {
    transform: translateX(-50%) translateY(0);
    visibility: visible;
    opacity: 1;
  }
</style>
